import React from 'react'
import NavbarDesktop from './desktop.navbar'
import NavbarComponent from './navbar.component';

const Navbar = () => {
  return (
    <div>
      <div className='flex'>
        {/* Desktop Navbar */}
        <NavbarDesktop />
      </div>
      <div className='hidden'>
        <NavbarComponent />
      </div>
    </div>
  )
}

export default Navbar;